<template>
	<div :id="this.id"></div>
</template>

<script>
	export default {
		name: "NightingalesRoseDiagram",
		props: {
			id:"",
			titleText: "",
			seriesName: "",
			seriesData: Array,
		},
		data(){
			return{
			}
		},
		methods: {
			draw() {
				let newPromise = new Promise((resolve) => {
					resolve()
				})
				newPromise.then(() => {
					this.$echarts.dispose(document.getElementById(this.id));
					var myChart = this.$echarts.init(document.getElementById(this.id));
		
					var option = {
						title: {
							text: this.titleText,
							left: 'center',
						},
						legend: {
							top: 'bottom',
						},
						tooltip: {
							trigger: 'item'
						},
						toolbox: {
							show: true,
							feature: {
								mark: {
									show: true
								},
								// dataView: {
								//   show: true,
								//   readOnly: false
								// },
								// restore: {
								//   show: true
								// },
								// saveAsImage: {
								//   show: true
								// }
							}
						},
						series: [{
							name: this.seriesName,
							type: 'pie',
							radius: [35, 175],
							center: ['50%', '50%'],
							roseType: 'area',
							itemStyle: {
								borderRadius: this.seriesData.length
							},
							data: this.seriesData
						}]
					};
		
					myChart.setOption(option);
				})
			}
		},
		watch: {
			seriesData:  {
				handler(val, oldVal) {
					this.draw();
				},
				deep: true,
				immediate: true,
			},
		},
		mounted(){
			console.log(this.$i18n);
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ECharts/NightingalesRoseDiagram.vue